import React from 'react'
import { compose } from 'recompose'
import { withStyles, Grid, Typography } from '@material-ui/core'
import EmojiObjectsIcon from '@material-ui/icons/ArrowBack'
import themeCreateInjectableStyles from 'Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support'
import PleaseWatiSpinnerStyle from './PleaseWatiSpinner.style'
import cn from 'classnames'
import Spinner from 'Components/Spinner/Spinner.component'

interface Props {
  content?: React.ReactNode,
}
interface InjectedProps {
  classes: any,
}
const PleaseWatiSpinnerComp = (props: Props & InjectedProps) => {
  const {
    classes,
  } = props
  return (
    <div className={classes.wrapper}>
      <Spinner />
      <Typography className={classes.waitingText} align='center' variant='h6'>
        { `Please wait` }
      </Typography>
    </div>
  )
}

const PleaseWatiSpinner = compose<Props & InjectedProps, Props>(
  withStyles(themeCreateInjectableStyles(PleaseWatiSpinnerStyle) as any, { withTheme: true }),
)(PleaseWatiSpinnerComp)

export default PleaseWatiSpinner
